// Loads the locale dictionary for / and /pricing before the page renders, so the
// prerendered HTML is already translated; the client hydrates it from the payload.
export default defineNuxtPlugin(async () => {
  const state = useHomeDictionary();
  const pricingState = usePricingPageCopyState();
  const localeState = useLocaleCopyState();

  const sync = async (path: string) => {
    const code = homeDictionaryLocale(path);
    await Promise.all([
      (async () => {
        const copyCode = code || 'en';
        if ((localeState.value?.code || 'en') !== copyCode) {
          localeState.value = copyCode === 'en' ? null : { code: copyCode, data: await loadLocaleCopy(copyCode) };
        }
      })(),
      (async () => {
        if (state.value.code !== code) state.value = { code, dict: code ? await loadHomeDictionary(code) : null };
      })(),
      (async () => {
        const pricingCode = code || 'en';
        if ((pricingState.value?.code || 'en') !== pricingCode) {
          pricingState.value = pricingCode === 'en' ? null : { code: pricingCode, copy: await loadPricingPageCopy(pricingCode) };
        }
      })(),
    ]);
  };

  await sync(import.meta.server ? useRequestURL().pathname : window.location.pathname);
  useRouter().beforeEach(async (to) => {
    await sync(to.path);
  });
});
